<template>
    <div class="jp">
        <div class="box clearfloat">
            <div class="box_fl" style="width: 519px;">
                <h1 class="fl_title">
                    <i class="icn01"></i> 竞买资源摘要
                    <i :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/06.png') + ')'}" class="icon06" v-if="jjxq.sfjjz===1 && xsjjPop"></i>
                    <span style="color: red; font-size: 20px; font-weight: 400; margin-left: 10px" v-if="jjxq.sfjjz===1 && xsjjPop">限时竞价提醒</span>
                </h1>
                <table v-if="jjxq.sfjjz===1 && xsjjPop">
                    <tbody>
                    <tr>
                        <td colspan="1" style="font-size: 15px; color: red; padding-top: 5px;">系统现已进入限时竞价环节，在此期间（即挂牌交易截止前5分钟内）<br>若任意竞买人有新报出价，则所有竞买人立即进入限时竞价阶段。</td>
                    </tr>
                    </tbody>
                </table>
                <table v-if="detail.zylxCode==='01' || detail.zylxCode==='05' || detail.zylxCode==='06'" border="1" class="tab">
                    <tr>
                        <th>公告号</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.ggbh"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>项目名称</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.xmmc"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>宗地编号</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.zdbh"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>规划用途分类</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.ghytText"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>所属区域</th>
                        <td v-text="detail.qyText"></td>
                        <th>交易方式</th>
                        <td>网上挂牌</td>
                    </tr>
                    <tr>
                        <th>挂牌起始时间</th>
                        <td v-text="detail.gpqssj"></td>
                        <th>挂牌截止时间</th>
                        <td v-text="jjxq.gpjzsj"></td>
                    </tr>
                    <tr>
                        <th>
                            <span v-show="detail.jgfsCode==='01'">起始价</span>
                            <span v-show="detail.jgfsCode==='02'">房价起始价</span>
                            <span v-show="detail.jgfsCode==='03'">房价起始价</span>
                            <span v-show="detail.jgfsCode==='04'">起始住房面积</span>
                            <span v-show="detail.jgfsCode==='05'">起始住房面积</span>
                        </th>
                        <td><span style="color: red;" v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        <th>
                            <span v-show="detail.jgfsCode==='01'">增加幅度</span>
                            <span v-show="detail.jgfsCode==='02'">减少幅度</span>
                            <span v-show="detail.jgfsCode==='03'">增加幅度</span>
                            <span v-show="detail.jgfsCode==='04'">增加幅度</span>
                            <span v-show="detail.jgfsCode==='05'">增加幅度</span>
                        </th>
                        <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                    </tr>
                    <tr>
                        <th>竞购方式</th>
                        <td>
                            <div style="word-break: break-word;max-width: 132px;" v-text="detail.jgfsText"></div>
                        </td>

                        <th v-show="detail.jgfsCode==='01'">保留价</th>
                        <td v-show="detail.jgfsCode==='01'" class="por_incn">
                            <span v-text="detail.sfydj ? '有' : '没有'" style="display: inline-block;width: 35px;height: 20px;"></span>
                            <div class="por_incn_hov" style="display: none;">
                                <i class="icn2"></i>
                                <p class="none_inc2">保留价是该拍品由商家设置能够接受的最低成交价。</p>
                            </div>
                        </td>

                        <th v-show="detail.jgfsCode==='02'">地价(万元)</th>
                        <td v-show="detail.jgfsCode==='02'"><span v-text="detail.djwy"></span> 万元</td>

                        <th v-show="detail.jgfsCode==='03'">房价(元)</th>
                        <td v-show="detail.jgfsCode==='03'"><span v-text="detail.fjy"></span> 元</td>

                        <th v-show="detail.jgfsCode==='04'">地价(万元)</th>
                        <td v-show="detail.jgfsCode==='04'"><span v-text="detail.djwy"></span> 万元</td>

                        <th v-show="detail.jgfsCode==='05'">地价(万元)</th>
                        <td v-show="detail.jgfsCode==='05'"><span v-text="detail.djwy"></span> 万元</td>
                    </tr>
                </table>

                <table v-else-if="detail.zylxCode==='03'" border="1" class="tab">
                    <tr>
                        <th>公告号</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.ggbh"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>项目名称</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.xmmc"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>矿权编号</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.zybh"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>规划用途分类</th>
                        <td colspan="3">
                            <div style="max-width: 393px;line-height: 25px;word-break: break-all;" v-text="detail.kcfs"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>所属区域</th>
                        <td v-text="detail.qyText"></td>
                        <th>交易方式</th>
                        <td>网上挂牌</td>
                    </tr>
                    <tr>
                        <th>挂牌起始时间</th>
                        <td v-text="detail.gpqssj"></td>
                        <th>挂牌截止时间</th>
                        <td v-text="jjxq.gpjzsj"></td>
                    </tr>
                    <tr>
                        <th>
                            <span>起始价</span>
                        </th>
                        <td><span style="color: red;" v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        <th>
                            <span>增加幅度</span>
                        </th>
                        <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                    </tr>
                    <tr>
                        <th>竞购方式</th>
                        <td v-text="detail.extData.sgfsText"></td>
                        <th>保留价</th>
                        <td v-text="detail.extData.sfydj"></td>
                    </tr>
                </table>

                <table v-else-if="detail.zylxCode==='04'" border="1" class="tab" >
                    <tr>
                        <th>公告号</th>
                        <td style="max-width: 393px;line-height: 25px;word-break: break-all;" colspan="3" v-text="detail.ggh"></td>
                    </tr>
                    <tr>
                        <th>项目名称</th>
                        <td style="max-width: 393px;line-height: 25px;word-break: break-all;" colspan="3" v-text="detail.xmmc"></td>
                    </tr>
                    <tr>
                        <th>耕地指标编号</th>
                        <td style="max-width: 393px;line-height: 25px;word-break: break-all;" colspan="3" v-text="detail.zybh"></td>
                    </tr>
                    <tr>
                        <th>所属区域</th>
                        <td v-text="detail.qyText"></td>
                        <th>交易方式</th>
                        <td>网上挂牌</td>
                    </tr>
                    <tr>
                        <th>挂牌起始时间</th>
                        <td v-text="detail.gpqssj"></td>
                        <th>挂牌截止时间</th>
                        <td v-text="detail.gpjzsj"></td>
                    </tr>
                    <tr>
                        <th>起始价</th>
                        <td>
                            <span style="color: red;">
                                {{detail.qsjwy}}
                            </span> 万元
                        </td>
                        <th v-text="detail.extData.xmjy.zjfsCode==='01' ? '增加幅度' : '减价幅度'"></th>
                        <td v-text="(detail.extData.xmjy.zjfsCode==='01' ? detail.extData.xmjy.zjfd : detail.extData.xmjy.jjfd) + ' 万元'"></td>
                    </tr>
                    <tr>
                        <th>竞购方式</th>
                        <td v-text="detail.extData.xmjy.jjfsText"></td>
                        <th>保留价</th>
                        <td class="por_incn">有</td>
                    </tr>
                </table>

            </div>
            <div :class="{ri:true,xianshi:jjxq.sfjjz===1,wanok:jjxq.sfjjz===3 && sfcj}">
                <div v-if="jjxq.sfjjz===1">
                    <div class="ri_title" v-if="jjxq.cur_time <= xmjyxq.freeEndTime">
                        <i class="icn3" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02.png') + ')'}"></i>
                        <span>正在挂牌</span>
                    </div>
                    <div class="ri_title" v-else>
                        <i class="icn_1" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_1.png') + ')',color:'red'}"></i>
                        <span style="color:red">限时竞价中</span>
                    </div>
                </div>
                <div v-else-if="jjxq.sfjjz===3">
                    <div class="ri_title" v-if="sfcj===null">
                        <span>交易结果正在确认，请稍等</span>
                    </div>
                    <div class="ri_title" v-else-if="sfcj">
                        <i class="icn_2" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_2.png') + ')'}"></i>
                        <span>已成交</span>
                    </div>
                    <div class="ri_title" v-else>
                        <i class="icn33" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_4.png') + ')'}"></i>
                        <span>已流拍</span>
                    </div>
                </div>
                <div class="item">
                    <p class="item_sheng">
                        交易剩余时间
                    </p>
                    <div class="item_dao clearfloat">
                        <p class="item_dao_fl">{{jjxq.day}}</p>
                        <p>天</p>
                        <p class="item_dao_fl">{{jjxq.hour}}</p>
                        <p>:</p>
                        <p class="item_dao_fl">{{jjxq.minute}}</p>
                        <p>:</p>
                        <p class="item_dao_fl">{{jjxq.second}}</p>
                    </div>
                </div>
                <div class="dangqian">
                    <p>当前最高出价</p>
                    <p v-if="jjxq.dqzgj && !noCj">
                        <span style="color: red;" v-text="jjxq.dqzgj">0</span>
                        <b style="font-weight: 400;" v-text="' '+detail.jgdwText"></b>
                    </p>
                    <p v-else>
                        <span style="color: red;">暂无报价</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="box2">
            <h2>
                <i class="icn05"></i> 出价记录
            </h2>
            <div class="box2_cont">
                <div class="box2_cont_title clearfloat">
                    <p>出价序号</p>
                    <p>竞买人报价</p>
                    <p>时间</p>
                </div>
                <div class="box2_cont_title clearfloat box2_cont_title11" v-for="(data,index) in jjxq.jjjl" :key="jjxq.jjjl.length - index">
                    <p class="cont_chujia"><span v-text="data.xh"></span></p>
                    <p><span v-text="data.quotePrice"></span> <span v-text="detail.jgdwText"></span></p>
                    <p v-text="data.quoteTime"></p>
                </div>
                <div class="tips" v-if="noCj">暂无出价记录</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {api} from '@/core/api'

    export default {
        name: "Jmxx",
        props: ["detail"],
        data() {
            return {
                xmjyxq: {  //交易项目信息
                    "ywlxID": "",
                    "bmjgID": "",
                    "jjsID": "",
                    "ggh": "",
                    "xmmc": "",
                    "zybh": "",
                    "ghyt": "",
                    "ssqy": "",
                    "jyfs": "",
                    "gpqssj": "",
                    "gpjzsj": "",
                    "qsj": "",
                    "zjfd": "",
                    "jgdw": "",
                    "jgfs": "",
                    "sfydj": "",
                    "xmdj": "",
                    "jmh": "",
                    "jmr": "",
                    "djwy": "",
                    "fjy": "",
                    "zjfsCode": "",
                    "freeEndTime": "",
                    "timeLimitedBiddingCycle": "",
                    "timeLimitedBiddingCycleNum": "",
                    "cjjls": "", //当前最高价
                    "sfbmcg": "" //是否报名成功，2报名未成功，1报名已成功、
                },
                jjxq: {  //竞价信息
                    "dqzgj": "", //当前最高价
                    "wxcjNum": "", //我想出价数字
                    "woyaochujia": "",
                    "sdjj": "", //手动加价
                    "jjfs": "1",//加价方式
                    "cjbs": "0", //出价倍数
                    "jjjl": [], //竞价记录
                    "sfjjz": "0", //是否竞价中
                    "gpjzsj": "",
                    "day": "", //剩余天数
                    "hour": "", //小时
                    "minute": "", //分钟
                    "second": "", //秒
                    "cur_time": ""
                },
                jjchenggongPop: false,
                xsjjPop: false,
                time1: null,
                time2: null,
                dycxs: true,
                sfcj: null,
            }
        },
        mounted() {
            this.sfcj = this.detail.extData.sfpmcg;
            api.getXmjyxq({jyywlx: this.detail.jyywlxCode, jyID: this.detail.jyID}).then(response => {
                if (response.data !== undefined) {
                    this.xmjyxq = response.data;
                    this.getJmxx();
                }
            });
        },
        methods: {
            getJmxx() {
                api.getJmxx({jyywlx: this.detail.jyywlxCode, jjsID: this.xmjyxq.jjsID}).then(response => {
                    if (response.data) {
                        if (this.jjxq.cur_time !== "" && this.xmjyxq.freeEndTime !== "") {
                            if (this.dycxs && this.jjxq.cur_time > this.xmjyxq.freeEndTime && response.data.sfjjz === 1) {
                                this.xsjjPop = true;
                                this.dycxs = false;
                            }

                            if (this.jjxq.cur_time > this.xmjyxq.freeEndTime && response.data.gpjzsj > this.jjxq.gpjzsj && response.data.sfjjz === 1) {
                                this.xsjjPop = true;
                            }
                        }

                        this.jjxq.dqzgj = response.data.dqzgj;
                        this.jjxq.jjjl = eval("(" + response.data.jjjl + ")");
                        this.jjxq.sfjjz = response.data.sfjjz;
                        this.jjxq.gpjzsj = response.data.gpjzsj;

                        this.jjxq.day = response.data.day;
                        this.jjxq.hour = response.data.hour;
                        this.jjxq.minute = response.data.minute;
                        this.jjxq.second = response.data.second;
                        this.jjxq.cur_time = response.data.cur_time;

                        if (this.jjxq.sfjjz === 3) {
                            this.jjxq.day = 0;
                            this.jjxq.hour = 0;
                            this.jjxq.minute = 0;
                            this.jjxq.second = 0;
                            this.getSfcj();
                        } else {
                            this.time1 = setTimeout(this.getJmxx, 1000)
                        }
                    }
                })
            },
            getSfcj() {
                api.getDetailById({category: "Gtzy", id: this.detail.id}).then(response => {
                    this.sfcj = response.data.extData.sfpmcg;
                    if (this.sfcj === null) {
                        this.time2 = setTimeout(this.getSfcj, 1000)
                    }
                });
            },
        },
        beforeDestroy() {
            clearTimeout(this.time1);
            clearTimeout(this.time2);
        },
        computed: {
            noCj() {
                return this.jjxq.jjjl !== undefined && this.jjxq.jjjl !== null && this.jjxq.jjjl.length <= 0;
            }
        }
    }
</script>
<style scoped src="../assets/Jmxx/css/index.css"></style>
<style scoped src="../assets/Jmxx/css/reset.css"></style>
<style scoped>
    .b_red {
        background-color: #fff8da;
    }

    .item_dao .item_dao_fl {
        width: 40px;
        height: 25px;
        background-image: linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        background-image: -moz-linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        background-image: -webkit-linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        background-image: -ms-linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        border-radius: 20px;
        text-align: center;
        line-height: 25px;
        color: #fff;
        margin: 0;
    }

    .xianshi .icn_1 {
        display: inline-block;
        width: 54px;
        height: 54px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 30px;
    }

    .ri_title .icn3 {
        display: inline-block;
        width: 54px;
        height: 54px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 30px;
    }

    .wanok .icn_2 {
        display: inline-block;
        width: 54px;
        height: 54px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 30px;
    }

    .tips {
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: #a6a6a6;
        margin-top: 10px;
    }

    .tab th {
        height: 39px;
        background-color: #f8f8f8;
        font-size: 14px;
        padding-right: 10px;
        padding-left: 8px;
        opacity: .5;
        text-align: left;
        font-weight: 700;
    }

    .tab td {
        padding: 0 10px;
        font-size: 14px;
        width: 135px;
    }

    .fl_title .icon06 {
        display: inline-block;
        width: 26px;
        height: 26px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-left: 30px;
    }
</style>
